// Definition: Contains all the environment variables used in the application.

// ENV Var for Heap App ID should use PRODUCTION App ID in the build, but
// use the STAGING App ID in the lower environment.
export const HEAP_APP_ID = process.env.REACT_APP_HEAP_APP_ID || "";
